import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";
import { errorMessageToast } from "../helper";

export const getDropdownData = async (key, group = "", opt = []) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/keyfunc`,
      {
        key,
        group: group,
        active: 1,
        company: 1,
        param1: "",
      },
    );

    return response.data.map((item) => {
      let data = {
        key: item.keyId,
        text: item.keyValue1,
        value: item.keyId,
      };

      opt.forEach((option) => {
        data = {
          ...data,
          [option]: item[option],
        };
      });

      return data;
    });
  } catch (e) {
    console.error(e);
  }
};

export const getBulkDropdownData = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/bulk/dropdown`,
      data,
    );

    return response.data;
  } catch (e) {
    console.error(e);
    return data.reduce((acc, item) => {
      if (item.group) {
        acc[`${item.key}#${item.group}`] = [];
      } else {
        acc[item.key] = [];
      }
      return acc;
    }, {});
  }
};

export const getOtherRefDropdown = async (type, value = "") => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/dropdown`,
      {
        type,
        value,
        active: 1,
        company: 1,
        param1: `string`,
      },
    );

    return response.data.map((item) => ({
      key: item.stkId,
      text: item.stkName,
      value: item.stkId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const getTemplateDropdown = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/template-dropdown`,
      data,
    );

    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getOtherRefSearchDropdown = async ({
  searchText,
  type,
  value,
  param1 = "",
  param2,
  param3,
  param4,
  param5,
  param6,
}) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/dropdownsearch`,
      {
        type,
        value,
        active: 1,
        company: 1,
        search: searchText,
        param1,
        param2,
        param3,
        param4,
        param5,
        param6,
      },
    );

    const uniqueItems = response.data.filter(
      (item, index, array) =>
        index === array.findIndex((findItem) => findItem.id === item.id),
    );

    return uniqueItems.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const getOtherRefSearchDropdownCount = async ({
  type,
  value,
  param1 = "",
  param2,
  param3,
  param4,
  param5,
  param6,
  reqCount,
}) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/dropdownsearch/count/${reqCount}`,
      {
        type,
        value,
        active: 1,
        company: 1,
        param1,
        param2,
        param3,
        param4,
        param5,
        param6,
      },
    );

    return response.data;
  } catch (e) {
    console.error(e);
    return -1;
  }
};

export const getTextByValueAndKey = async (value, id) => {
  try {
    if (value != null && id != null) {
      const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/textbykey`,
        {
          value,
          id,
        },
      );
      return response.data.data[0];
    }
  } catch (e) {
    console.error(e);
  }
};

export const getByValueAndKey = async (value, id) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/dropdownbykeyandseq/${id}`,
      value,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

/*
    Example:
    Request
    {
        `tableName`: `masterdata.tms_m_stakeholder`,
        `primaryKey`: `stk_id`,
        `fieldNames`: `stk_name,stk_code`,
        `ids`: `45,46`
    }

    Response
    [
    {
        `pkId`: 46,
        `field1`: `Stakeholder 20`,
        `field2`: `STK-00000046`,
        `field3`: "",
        `field4`: ""
    },
    {
        `pkId`: 45,
        `field1`: `Sample Stakeholder 12`,
        `field2`: `STK-00000045`,
        `field3`: "",
        `field4`: ""
    }
]
*/

export const getFieldValuesByTableAndId = async ({
  tableName,
  primaryKey,
  fieldNames,
  ids,
  searchField = "",
  keyType = `B`,
  caseSensitive = false,
}) => {
  try {
    if (!tableName || !primaryKey || !fieldNames || !ids) {
      console.error(`Invalid parameters - `, {
        sTableName: tableName,
        sFields: fieldNames,
        sPrimaryKey: primaryKey,
        sKeys: ids,
      });

      return [
        {
          sTableName: tableName,
          sFields: fieldNames,
          sPrimaryKey: primaryKey,
          sKeys: ids,
        },
      ];
    }

    if (
      tableName === "" ||
      primaryKey === "" ||
      fieldNames === "" ||
      ids === ""
    ) {
      console.error(`Invalid parameters`);
      return [""];
    }
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/tabledata`,
      {
        sTableName: tableName,
        sFields: fieldNames,
        sPrimaryKey: primaryKey,
        sKeys: ids,
        sSearchField: searchField,
        sKeyType: keyType,
        sCase: caseSensitive ? `CS` : `CIS`,
      },
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getOtherRefTextByValueAndKey = async (type, value, id) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/otherreftextbykey`,
      {
        type,
        value,
        id,
      },
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};

export const behalfOfKeyValue = async (
  usrUsername = "",
  customer = "",
  shipper = "",
) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/costomerUser/customerUser_fun`,
      {
        usrUsername,
        customer,
        shipper,
      },
    );

    return response.data.map((item) => ({
      key: item.usrId,
      text: item.usrUsername,
      value: item.usrId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const getOtherRefDetails = async ({
  type,
  value = "",
  searchText = "",
  param2 = "",
  active = 1,
  company = null,
  param3 = "",
  param4 = "",
  param5 = "",
  param6 = "",
}) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/dropdownsearchfull`,
      {
        sType: type,
        sValue: value,
        sParam1: searchText,
        sParam2: param2,
        lActive: active,
        lCompany: company,
        sParam3: param3,
        sParam4: param4,
        sParam5: param5,
        sParam6: param6,
      },
    );
    return response.data.map((item) => ({
      ...item,
      key: item.retId,
      title: item.retField1,
      value: item.retId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const checkForDuplicates = async ({
  tableName,
  primaryKeyCol,
  columnName,
  searchText,
  activeCol,
  companyCol = "-2",
  isCaseSensitive = false,
}) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/keyvalues/duplicate-check`,
      {
        tableName,
        primaryKeyCol,
        columnName,
        searchText,
        activeCol,
        companyCol,
        isCaseSensitive,
      },
    );
    return response.data;
  } catch (e) {
    console.error(e);
    errorMessageToast(e);
    return null;
  }
};

export const getCustomerConsigneeSearchDropdown = async ({ searchText, param2 }) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/customerConsignee/search-dropdown`,
            {
                params: {
                    customerId: param2,
                    search: searchText,
                },
            },
        );

        return response.data.map((item) => ({
            key: item.id,
            title: item.text,
            value: item.value,
        }));
    } catch (e) {
        console.error(e);
    }
};
